import React from 'react';

import {DEFAULT_DATE_FORMAT, DEFAULT_DATE_TIME_FORMAT} from 'helpers/constants';

export const DictionaryContext = React.createContext({});

export const DateFormatContext = React.createContext({
  dateFormat: DEFAULT_DATE_FORMAT,
  dateTimeFormat: DEFAULT_DATE_TIME_FORMAT,
});



// WEBPACK FOOTER //
// ./src/components/Common/DictionaryContext.js